import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documents-contractuels',
  templateUrl: './documents-contractuels.component.html',
  styleUrls: ['./documents-contractuels.component.scss']
})
export class DocumentsContractuelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
